import * as normalize from 'utils/normalize';
import getPatientName from 'utils/print/getPatientName';
import getPatientMedicareID from 'utils/print/getPatientMedicareID';
import getOrderLineNarrativeDescriptionAndCost from 'utils/print/getOrderLineNarrativeDescriptionAndCost';
import getSignature from 'utils/print/getSignature';

const CMS854 = {
  ID: 8,
  Name: 'CMS-854 Continuation Form',
  Type: 'CMS',
  Format: 'letter',
  Orientation: 'p',
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/CMS-854/1.js',
      fields: [
        {
          name: 'Patient Name',
          type: 'text',
          getValue: getPatientName,
          x: 38,
          y: 30,
          width: 69,
          height: 8.5,
          multiline: true,
        },
        {
          name: 'Medicare ID',
          type: 'text',
          getValue: getPatientMedicareID,
          x: 129,
          y: 30,
          width: 73,
          height: 8.5,
          multiline: true,
        },
        {
          name: '(1) Narrative description of all items, accessories and options ordered; (2) Suppliers charge; and (3) Medicare Fee Schedule Allowance for each item, accessory and option',
          type: 'text',
          getValue: getOrderLineNarrativeDescriptionAndCost,
          x: 14,
          y: 55,
          width: 188,
          height: 174,
          multiline: true,
        },
        {
          name: 'Signature',
          type: 'signature',
          getValue: getSignature,
          x: 55,
          y: 252,
          width: 90,
          height: 10,
        },
        {
          name: 'Date 1',
          type: 'text',
          x: 175,
          y: 257.5,
          width: 8,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Date 2',
          type: 'text',
          x: 184,
          y: 257.5,
          width: 8,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Date 3',
          type: 'text',
          x: 193,
          y: 257.5,
          width: 8,
          maxLength: 2,
          normalize: normalize.number,
        },
      ],
    },
  ],
};

export default CMS854;



// WEBPACK FOOTER //
// ./src/config/documents/CMS-854.js